module.exports = __webpack_public_path__ + "media/pro/50-dfe3c3e9.png";